import React from "react";
import PropTypes from "prop-types";
import { Select, MenuItem } from "@mui/material";
import { ErrorMessage } from "formik";

const SelectInputField = ({
  label,
  field,
  form,
  options,
  className,
  ...rest
}) => {
  const errorId = `${field.name}-error`;
  const hasError = form.errors[field.name] && form.touched[field.name];

  const labelId = `${field.name}-label`;

  return (
    <div className={className}>
      <span className="form-field-header">
        {label && <label id={labelId} className="form-field-label" htmlFor={field.name}>{label}</label>}
      </span>
      <span
        id={errorId}
        className="form-field-error"
        role="alert"
        aria-live="polite"
        style={{ display: 'block', marginTop: '4px', marginBottom: '4px', color: '#ec0f0f', fontSize: '0.875rem' }}
      >
        <ErrorMessage name={field.name} />
      </span>
      <Select
        labelId={labelId}
        aria-labelledby={labelId}
        id={field.name}
        name={field.name}
        value={field.value}
        type="radio"
        className="input-field"
        onChange={form.handleChange}
        onBlur={x => {
          field.onBlur(x);
        }}
        style={{ margin: 0 }}
        error={hasError}
        inputProps={{
          'aria-describedby': hasError ? errorId : undefined,
          'aria-invalid': hasError
        }}
        {...rest}
      >
        {options.map(({ text, value }, index) => (
          <MenuItem key={`${value}-${index}`} value={value}>
            {text}
          </MenuItem>
        ))}
      </Select>
    </div>
  );
};

SelectInputField.propTypes = {
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      test: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
    })
  ).isRequired,
  field: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    onBlur: PropTypes.func.isRequired
  }),
  form: PropTypes.shape({
    setFieldValue: PropTypes.func.isRequired,
    handleChange: PropTypes.func.isRequired
  }).isRequired,
  className: PropTypes.string
};

SelectInputField.defaultProps = {
  className: "form-field"
};

export default SelectInputField;
